import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/Hero.css"; // CSS for styling
import hero1 from "../../assets/hero_1.png";
import hero2 from "../../assets/hero_2.png";
import hero3 from "../../assets/hero_3.png";
import hero4 from "../../assets/hero_4.png";
import hero5 from "../../assets/hero_5.png";
import Aos from "aos"; // Animation on scroll library
import "aos/dist/aos.css";

class HeroSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scrollPercentage: 0,
        };
    }

    componentDidMount() {
        // Initialize AOS animations
        Aos.init({ duration:600, once: false, mirror: true });

        // Attach scroll listener to animate vertical line
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        // Cleanup scroll listener
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        const heroSection = document.querySelector(".hero-section-wrapper");

        if (heroSection) {
            const scrollTop = window.pageYOffset; // Current scroll position
            const sectionTop = heroSection.offsetTop; // HeroSection top relative to the document
            const sectionHeight = heroSection.offsetHeight; // Total height of the HeroSection
            const viewportHeight = window.innerHeight; // Height of the visible viewport

            const visibleTop = Math.max(0, scrollTop - sectionTop); // Scrolled area within HeroSection
            const visibleHeight = Math.min(sectionHeight, viewportHeight); // Visible part of HeroSection

            const scrollPercentage = Math.min(
                (visibleTop / (sectionHeight - visibleHeight)) * 100,
                100
            ); // Calculate scroll percentage (capped at 100%)

            this.setState({ scrollPercentage });
        }
    };

    render() {
        const { scrollPercentage } = this.state;

        return (
            <div className="hero-section-wrapper">
                {/* Vertical Line */}
                <div
                    className="hero-line"
                    style={{
                        height: `${this.state.scrollPercentage}%`, // Adjust the height dynamically
                    }}
                ></div>

                {/* Hero Item 1 */}
                <section className="hero-item">
                    <div className="hero-text" data-aos="fade-right">
                        <h1>Increase Revenue</h1>
                        <p className="subtext">
                            Automate lead generation, follow-ups, and personalized marketing campaigns to turn more prospects into paying customers — without lifting a finger.
                        </p>
                        <NavLink to="/contact" className="cta-button">
                            Book a Free Automation Call
                        </NavLink>
                    </div>
                    <div className="hero-image" data-aos="fade-left">
                        <img src={hero1} alt="Increase Revenue" className="screenshot" />
                    </div>
                </section>

                {/* Hero Item 2 */}
                <section className="hero-item reverse">
                    <div className="hero-text" data-aos="fade-left">
                        <h1>Decrease Costs</h1>
                        <p className="subtext">
                            Reduce your reliance on large teams and expensive tools by automating your workflows with scalable, custom AI systems.
                        </p>
                        <NavLink to="/contact" className="cta-button">
                            Schedule Your Strategy Call
                        </NavLink>
                    </div>
                    <div className="hero-image" data-aos="fade-right">
                        <img src={hero2} alt="Decrease Costs" className="screenshot" />
                    </div>
                </section>

                {/* Hero Item 3 */}
                <section className="hero-item">
                    <div className="hero-text" data-aos="fade-right">
                        <h1>Save Time Every Day</h1>
                        <p className="subtext">
                            We eliminate repetitive tasks — from content creation to client outreach — so you and your team can stay focused on high-impact work.
                        </p>
                        <NavLink to="/contact" className="cta-button">
                            Contact Us
                        </NavLink>
                    </div>
                    <div className="hero-image" data-aos="fade-left">
                        <img src={hero3} alt="Save Time" className="screenshot" />
                    </div>
                </section>

                {/* Hero Item 4 */}
                <section className="hero-item reverse">
                    <div className="hero-text" data-aos="fade-left">
                        <h1>Work Smarter, Not Harder</h1>
                        <p className="subtext">
                            Replace hours of manual work with AI-powered systems that work for you 24/7 — no burnout, just consistent results.
                        </p>
                        <NavLink to="/contact" className="cta-button">
                            Let’s Automate Your Business
                        </NavLink>
                    </div>
                    <div className="hero-image" data-aos="fade-right">
                        <img src={hero4} alt="Work Smarter" className="screenshot" />
                    </div>
                </section>

                {/* Hero Item 5 */}
                <section className="hero-item">
                    <div className="hero-text" data-aos="fade-right">
                        <h1>Build Once, Grow Forever</h1>
                        <p className="subtext">
                            Our automations don’t just save time today — they create a growth engine that compounds value every week.
                        </p>
                        <NavLink to="/contact" className="cta-button">
                            Talk to an Automation Expert
                        </NavLink>
                    </div>
                    <div className="hero-image" data-aos="fade-left">
                        <img src={hero5} alt="Build Once, Grow Forever" className="screenshot" />
                    </div>
                </section>

            </div>
        );
    }
}

export default HeroSection;